import {
  Button,
  Checkbox,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Switch,
  Textarea,
  Typography
} from "@material-tailwind/react";
import React, {useContext, useEffect, useState} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {ServiceContext} from "../../context/service";
import Validator from "../../helper/validator/Validator";
import {ValidatorProvider} from "../../helper/validator/ValidatorContext";
import {submitService} from "../../services/service/service";
import {checkAll} from "../../helper/validator/Check";
import {Toaster} from "../../helper/Toaster";
import {submitBackOfficeService} from "../../services/back_office/service";
import {toast} from "react-toastify";

export function ConfirmationForm({person_id}) {

  const [sideCostPayer, setSideCostPayer] = useState(true)
  const [multiPayment, setMultiPayment] = useState(false)
  const [isChecked, setIsChecked] = useState(false)

  const [personId, setPersonId] = useState(person_id)

  useEffect(() => {
    setPersonId(person_id)
  }, [person_id]);

  const [buttonLoading, setButtonLoading] = useState(false)

  const {
    service,
    setService,
    setStep,
    modalOpen,
    setModalOpen,
    branchInfo,
    setLastDataRefresh
  } = useContext(ServiceContext);


  const handleOpen = () => setModalOpen(!modalOpen);

  const save = async () => {


    setButtonLoading(true)
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      toast.error("مقادیر الزامی را بر اساس راهنما تکمیل کنید");
      setButtonLoading(false)
      return
    }

    const data = {
      agent_id: service.agent_id,
      branch_id: branchInfo.id,
      topic: service.topic,
      challenge: service.challenge,
      side_cost_payer: sideCostPayer ? "agent" : "person",
      multi_payment: multiPayment,
    };
    let result;

    if (!personId) {
      result = await submitService(data);
    } else {
      data.person_id = personId;
      result = await submitBackOfficeService(data);
    }

    if (result.status === 201) {
      const {person_service} = result.data;
      setService(person_service);
      setLastDataRefresh(Date.now())
      setStep("check")
      setButtonLoading(false)
    } else {
      setButtonLoading(false)
    }
  };

  return (
    <ValidatorProvider>
      <Dialog size="md" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen mt-20 bg-none">
        <DialogHeader className="bg-gray-800 rounded-2xl -mt-4">
          <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
            استعلام قیمت خدمات
          </Typography>
        </DialogHeader>

        <DialogBody className="flex flex-col w-full gap-4 rounded-2xl overflow-y-scroll">

          <div className="flex flex-row border-b-2 mb-2">
            <Typography className="flex flex-col ml-2">
              {`${Dict('agent')}: `}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {service.agent_name}
            </Typography>
          </div>

          <div className="flex flex-row border-b-2 mb-2">
            <Typography className="flex flex-col ml-2">
              {`${Dict('branch_title')}: `}
            </Typography>
            <Typography className="flex flex-col" color="blue-gray">
              {branchInfo.branch_title}
            </Typography>
          </div>

          {branchInfo?.consensual &&
            <div className="grid flex-row grid-cols-1 w-full md:grid-cols-2 xxl:grid-cols-3 pb-2 border-b-2">
              <div className="mb-4 md:ml-3">
                <div className="flex flex-row border-l-2">
                  <Typography className="flex flex-col ml-2">
                    {Dict('min_service_price') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.min_price, true) + " ریال"}
                  </Typography>
                </div>
              </div>

              <div className="mb-4 md:mr-3">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2">
                    {Dict('max_service_price') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.max_price, true) + " ریال"}
                  </Typography>
                </div>
              </div>
            </div>
          }
          {!branchInfo?.consensual &&
            <div className="grid grid-cols-1 md:grid-cols-2 xxl:grid-cols-3">
              <div className="flex flex-row">
                <Typography className="flex flex-col ml-2">
                  {Dict('service_price') + ": "}
                </Typography>
                <Typography className="flex flex-col" color="blue-gray">
                  {persianNumberFormat(branchInfo.price, true) + " ریال"}
                </Typography>
              </div>
            </div>
          }

          {branchInfo.side_cost &&
            <>
              <Checkbox
                checked={branchInfo.side_cost}
                label={
                  <Typography color="blue-gray" className="flex font-medium">
                    هزینه‌های جانبی
                  </Typography>
                }
              />
              <div className="mb-4 flex flex-col pb-2 border-b-2">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2 mb-4">
                    {Dict('side_cost_description') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {branchInfo.side_cost_description}
                  </Typography>
                </div>
              </div>
            </>
          }

          <div className="grid flex-row grid-cols-1 gap-6 mt-2 pb-2 border-b-2 md:grid-cols-2 xxl:grid-cols-3">
            {!branchInfo.period &&
              <div className="mb-4">
                <div className="flex flex-row">
                  <Typography className="flex flex-col ml-2 mb-4">
                    {Dict('service_day') + ": "}
                  </Typography>
                  <Typography className="flex flex-col" color="blue-gray">
                    {persianNumberFormat(branchInfo.day) + " روز"}
                  </Typography>
                </div>
              </div>
            }
            {branchInfo.period &&
              <>
                <div className="mb-4 border-l-2">
                  <div className="flex flex-row">
                    <Typography className="flex flex-col ml-2">
                      {Dict('min_service_day') + ": "}
                    </Typography>
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(branchInfo.min_day) + " روز"}
                    </Typography>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="flex flex-row">
                    <Typography className="flex flex-col ml-2">
                      {Dict('max_service_day') + ": "}
                    </Typography>
                    <Typography className="flex flex-col" color="blue-gray">
                      {persianNumberFormat(branchInfo.max_day) + " روز"}
                    </Typography>
                  </div>
                </div>
              </>
            }
          </div>

          <div className="flex flex-row my-4 h-fit">
            <div className="flex flex-col w-full">
              <Input variant="standard"
                     label={Dict("service_topic")}
                     placeholder={Dict("service_topic")}
                     value={service.topic}
                     onChange={(e) =>
                       setService(service => ({
                         ...service,
                         topic: e.target.value,
                       }))
                     }
              />
              <Validator isChecked={isChecked} state={service.topic} rules="required"/>
            </div>
          </div>

          <div className="flex flex-row mb-4 h-fit">
            <Textarea variant="standard"
                      label={Dict("challenge")}
              // placeholder={Dict("challenge")}
                      value={service.challenge}
                      onChange={(e) =>
                        setService(service => ({
                          ...service,
                          challenge: e.target.value,
                        }))
                      }
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  پرداخت هزینه‌های دولتی و جانبی توسط مشاور
                </Typography>
              }
              checked={sideCostPayer}
              onChange={(e) => {
                setSideCostPayer(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>

          <div className="">
            <Switch
              label={
                <Typography color="blue-gray" className="font-medium">
                  پرداخت دو مرحله‌ای
                </Typography>
              }
              checked={multiPayment}
              onChange={(e) => {
                setMultiPayment(e.target.checked)
              }}
              labelProps={{className: "mx-4"}}
            />
          </div>

          <div className="flex flex-row justify-end mt-4 left-0 md:mt-0">
            <Button variant="text" color="gray" onClick={() => {
              setModalOpen(false)
            }}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" size="sm md:lg" loading={buttonLoading} disabled={buttonLoading}
                    onClick={save}
                    className="ml-1">
              <span>استعلام قیمت</span>
            </Button>
          </div>


        </DialogBody>

        {/*<DialogFooter className="space-x-2 textLeft">*/}

        {/*  */}
        {/*</DialogFooter>*/}
      </Dialog>
    </ValidatorProvider>
  );
}
